import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SearchIcon2: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 14 15"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<g clipPath="url(#clip0_3938_69062)">
				<path
					d="M6.54 12.14C9.37 12.14 11.67 9.85 11.67 7.01C11.67 4.18 9.37 1.89 6.54 1.89C3.71 1.89 1.41 4.18 1.41 7.01C1.41 9.85 3.71 12.14 6.54 12.14Z"
					stroke="white"
					strokeWidth="1.13958"
				/>
				<path d="M10.19 10.66L12.81 13.28" stroke="white" strokeWidth="1.13958" />
			</g>
			<defs>
				<clipPath id="clip0_3938_69062">
					<rect width="13.675" height="13.675" fill="white" transform="translate(0.27 0.75)" />
				</clipPath>
			</defs>
		</svg>
	)
}

export default SearchIcon2
